import _ from 'lodash';

export default function (instance) {
  return {
    getImpactStats(config = {}) {
      return instance.get('report/partner/summary/', config);
    },
  };
}
